// src/components/Meetings.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
    Container,
    Typography,
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Button,
    TextField,
    Grid,
    MenuItem,
    IconButton
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from 'react-router-dom';
const API_URL = process.env.REACT_APP_API_URL || '';

const Meetings = () => {
    const [meetings, setMeetings] = useState([]);
    const [form, setForm] = useState({
        title: '',
        description: '',
        meeting_date: '',
        meeting_time: '',
        client_id: '',
        meeting_type: '',
        status: '',
        notes: ''
    });
    const token = localStorage.getItem('token');
    const navigate = useNavigate();

    const fetchMeetings = async () => {
        try {
            const response = await axios.get(`${API_URL}/api/meetings`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setMeetings(response.data);
        } catch (error) {
            console.error('Error fetching meetings:', error);
        }
    };

    useEffect(() => {
        fetchMeetings();
    }, [token]);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await axios.post(`${API_URL}/api/meetings`, form, {
                headers: { Authorization: `Bearer ${token}` }
            });
            fetchMeetings();
            setForm({
                title: '',
                description: '',
                meeting_date: '',
                meeting_time: '',
                client_id: '',
                meeting_type: '',
                status: '',
                notes: ''
            });
        } catch (error) {
            console.error('Error adding meeting:', error);
        }
    };

    return (
        <Container maxWidth="lg">
            <Box sx={{ mt: 4 }}>
                <Typography variant="h4" gutterBottom>
                    Spotkania
                </Typography>
                <Paper sx={{ p: 2, mb: 4 }}>
                    <Typography variant="h6">Dodaj nowe spotkanie</Typography>
                    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label="Tytuł"
                                    name="title"
                                    value={form.title}
                                    onChange={handleChange}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label="Opis"
                                    name="description"
                                    value={form.description}
                                    onChange={handleChange}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    fullWidth
                                    label="Data spotkania"
                                    name="meeting_date"
                                    type="date"
                                    value={form.meeting_date}
                                    onChange={handleChange}
                                    InputLabelProps={{ shrink: true }}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    fullWidth
                                    label="Godzina"
                                    name="meeting_time"
                                    type="time"
                                    value={form.meeting_time}
                                    onChange={handleChange}
                                    InputLabelProps={{ shrink: true }}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    fullWidth
                                    label="ID klienta"
                                    name="client_id"
                                    value={form.client_id}
                                    onChange={handleChange}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    select
                                    fullWidth
                                    label="Typ spotkania"
                                    name="meeting_type"
                                    value={form.meeting_type}
                                    onChange={handleChange}
                                    required
                                >
                                    <MenuItem value="sales">sales</MenuItem>
                                    <MenuItem value="support">support</MenuItem>
                                    <MenuItem value="implementation">implementation</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    select
                                    fullWidth
                                    label="Status"
                                    name="status"
                                    value={form.status}
                                    onChange={handleChange}
                                    required
                                >
                                    <MenuItem value="scheduled">scheduled</MenuItem>
                                    <MenuItem value="completed">completed</MenuItem>
                                    <MenuItem value="cancelled">cancelled</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    label="Notatki"
                                    name="notes"
                                    value={form.notes}
                                    onChange={handleChange}
                                    multiline
                                    rows={3}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Button type="submit" variant="contained" color="primary">
                                    Dodaj spotkanie
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                </Paper>
                <Paper sx={{ p: 2 }}>
                    <Typography variant="h6" gutterBottom>
                        Lista spotkań
                    </Typography>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>ID</TableCell>
                                <TableCell>Tytuł</TableCell>
                                <TableCell>Opis</TableCell>
                                <TableCell>Data</TableCell>
                                <TableCell>Godzina</TableCell>
                                <TableCell>ID klienta</TableCell>
                                <TableCell>Typ spotkania</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Notatki</TableCell>
                                <TableCell>Utworzony</TableCell>
                                <TableCell>Akcje</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {meetings.map(meeting => (
                                <TableRow key={meeting.id}>
                                    <TableCell>{meeting.id}</TableCell>
                                    <TableCell>{meeting.title}</TableCell>
                                    <TableCell>{meeting.description}</TableCell>
                                    <TableCell>{meeting.meeting_date}</TableCell>
                                    <TableCell>{meeting.meeting_time}</TableCell>
                                    <TableCell>{meeting.client_id}</TableCell>
                                    <TableCell>{meeting.meeting_type}</TableCell>
                                    <TableCell>{meeting.status}</TableCell>
                                    <TableCell>{meeting.notes}</TableCell>
                                    <TableCell>{new Date(meeting.created_at).toLocaleString()}</TableCell>
                                    <TableCell>
                                        <IconButton color="primary" onClick={() => navigate(`/meetings/edit/${meeting.id}`)}>
                                            <EditIcon />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Paper>
            </Box>
        </Container>
    );
};

export default Meetings;